export enum AppScreen {
    Loading = 'loading',
    Welcome = 'welcome',
    Upload = 'upload',
    HomeLocation = 'home-location',
    Dashboard = 'dashboard',
    Map = 'map',
    WrapUp = 'wrap-up',
    CalibrateData = 'calibrate-data',
    Discover = 'discover',
    BigYear = 'big-year',
    FamilyExplorer = 'family-explorer',
    HotspotExplorer = 'hotspot-explorer'
}
